import { Component, OnInit, Input } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

import 'moment/locale/pt-br';

// Service
import { CockpitService } from '../../../service/cockpit/cockpit.service';

@Component({
	selector: 'app-prolongation-proposal',
	templateUrl: './prolongation-proposal.component.html',
	providers: [
		CockpitService,
		HttpModule
	]
})
export class CockpitProlongationProposalComponent implements OnInit {

	@Input('follow') follow: boolean;

	public extensionProposals: any[] = [];
	public orderby: string = "NumeroInternoProposta";
	public sort: string = "asc";

	constructor(private CockpitService: CockpitService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		this.getExtensionProposal();
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getExtensionProposal();
	}

	getExtensionProposal() {
		this.CockpitService.getExtensionProposal(this.follow, this.orderby, this.sort).subscribe(result => {
			if (result.Success) {
				this.extensionProposals = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/prolongation-proposal/prolongation-proposal.component.ts